import { render } from "./otherBlocks.vue?vue&type=template&id=f86be1ca&scoped=true&ts=true"
import script from "./otherBlocks.vue?vue&type=script&lang=ts"
export * from "./otherBlocks.vue?vue&type=script&lang=ts"

import "./otherBlocks.vue?vue&type=style&index=0&id=f86be1ca&scoped=true&lang=css"

import exportComponent from "E:\\dyy\\备份\\百廿官网\\bnkjgw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f86be1ca"]])

export default __exports__